module.exports = __webpack_public_path__ + "img/icon-team-type-2.b6e3872c.png";